export const stepsTotal = 2;
export const contactDetailsStep = 1;
export const passwordStep = 2;
